import { Component } from "@angular/core";

@Component({
    selector: "unauthorized",
    templateUrl: "./unauthorized.html",
    styleUrls: ["unauthorized.scss"],
    standalone: false
})
export class UnauthorizedComponent {
  constructor() {}

  ngOnInit(): void {}
}
